<template>
  <div class="pa-0 ma-0">
    <v-container v-if="!adminMode && !isEmpty" class="pa-0 ma-auto mt-6">
      <v-container v-if="published" class="text--primary px-3 mx-auto">
        <TextMarkdown :text="infopair.text"></TextMarkdown>
        <!--<span style="white-space: pre-line;">{{ infopair.text }}</span>-->
      </v-container>
      <MediaComponent
        :media="infopair.media"
        :slot-width="initWindowWidth > 900 ? 900 : initWindowWidth"
        :slot-height="initWindowHeight - 150"
      ></MediaComponent>
    </v-container>

    <v-card v-if="adminMode" outlined class="pa-0 ma-4">
      <v-alert v-model="showErrorAlert" type="error" dismissible>
        {{
        errorMessage
        }}
      </v-alert>
      <v-form v-model="formIsValid" ref="form">
        <v-container class="text--primary px-3">
          <v-row>
            <v-col cols="10" sm="11">
              <TextMarkdown v-if="!editingMode" :text="text"></TextMarkdown>

              <v-textarea v-if="editingMode" outlined v-model="text" hide-details="auto" auto-grow></v-textarea>
            </v-col>
            <v-col cols="2" sm="1" class="py-2">
              <EditButton v-if="adminMode && !editingMode" @click="editingMode = true"></EditButton>
              <v-btn
                v-if="editingMode"
                icon
                :loading="apiLoadingData"
                color="green"
                @click="updateInfoPairText"
              >
                <v-icon>mdi-check-outline</v-icon>
              </v-btn>
              <v-btn v-if="editingMode" icon color="red" @click="cancelEditing">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>

        <MediaComponent
          :media="infopair.media"
          :slot-width="windowWidth > 900 ? 900 - 50 : windowWidth - 50"
          :slot-height="windowHeight - 150"
        ></MediaComponent>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import { adminOptionsComputed } from '@/store/helpers.js'
import { editingLogicMixin } from '@/components/mixins/editing'
import { vueWindowSizeMixin } from 'vue-window-size'

import MediaComponent from '@/components/MediaComponent.vue'
import EditButton from '@/components/EditButton.vue'
import TextMarkdown from '@/components/TextMarkdown.vue'

export default {
  components: {
    MediaComponent,
    EditButton,
    TextMarkdown
  },
  mixins: [editingLogicMixin, vueWindowSizeMixin],
  props: {
    infopair: {
      type: Object,
      required: true
    },
    published: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      text: '',
      initWindowWidth: 0,
      initWindowHeight: 0
    }
  },
  computed: {
    ...adminOptionsComputed,
    isEmpty() {
      if (!this.infopair.media && this.infopair.text == '') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.initWindowWidth = this.windowWidth
    this.initWindowHeight = this.windowHeight
  },
  methods: {
    updateInfoPairText() {
      this.updateData(APIService.updateInfoPair, this.infopair.id)
    },
    //
    // Методы связаннные с изменением инфопары в базе
    // Остальные методы и переменные для изменений в базе берутся из миксина editing.js
    //
    initData() {
      this.text = this.infopair.text
    },
    setData() {
      const apiData = {}
      apiData.text = this.text

      return apiData
    }
  }
}
</script>
